<nb-card class="mb-0 draft-product-dialog">
  <nb-card-header>{{ 'INVOICE_IMPORTS.PHASE2.DRAFT_PRODUCT_TITLE' | translate }}</nb-card-header>
  <nb-card-body>
    <form [formGroup]="form">
      <div class="mb-3">
        <label class="form-label">{{ 'INVOICE_IMPORTS.PHASE2.DRAFT_NAME' | translate }}</label>
        <input class="form-control" formControlName="name" />
      </div>
      <div class="mb-3">
        <label class="form-label">{{ 'INVOICE_IMPORTS.PHASE2.DRAFT_PRICE' | translate }}</label>
        <input type="number" class="form-control" formControlName="price" step="0.01" />
      </div>
      <div class="mb-3">
        <label class="form-label">{{ 'INVOICE_IMPORTS.PHASE2.DRAFT_CATEGORY' | translate }}</label>
        <select class="form-select" formControlName="categoryId">
          <option value="">{{ 'INVOICE_IMPORTS.PHASE2.DRAFT_CATEGORY_PLACEHOLDER' | translate }}</option>
          <option *ngFor="let c of categories" [value]="c._id">{{ c.name }}</option>
        </select>
      </div>
      <p class="small text-muted mb-0">{{ 'INVOICE_IMPORTS.PHASE2.DRAFT_HINT' | translate }}</p>
    </form>
  </nb-card-body>
  <nb-card-footer class="d-flex justify-content-end gap-2">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
      {{ 'INVOICE_IMPORTS.COMMON.CANCEL' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="submit()">
      {{ 'INVOICE_IMPORTS.PHASE2.DRAFT_CREATE' | translate }}
    </button>
  </nb-card-footer>
</nb-card>
